<template>
    <div class="flex flex-col gap-3">
        <ul class="flex flex-col gap-1 text-sm">
            <li v-for="document in documents" :key="document.documentType">
                <a
                    :href="document.url"
                    target="_blank"
                    rel="noopener"
                    class="text-theme-primary underline"
                >
                    {{ labelOf(document.documentType) }}
                </a>
            </li>
        </ul>
        <custom-checkbox
            v-for="group in visibleGroups"
            :key="group.key"
            :checked="checkedKeys.includes(group.key)"
            primary
            @change="toggleGroup(group.key)"
        >
            <span>{{ group.label }}</span>
        </custom-checkbox>
    </div>
</template>

<script>
import {
    LEGAL_CONSENT_GROUPS,
    LEGAL_DOCUMENT_LABELS
} from "@/common/fields/legal-documents";

import CustomCheckbox from "@/components/utils/CustomCheckbox.vue";

export default {
    name: "LegalConsentCheckboxes",
    components: { CustomCheckbox },
    props: {
        documents: { type: Array, default: () => [] },
        value: { type: Boolean, default: false }
    },
    emits: ["input"],
    data: () => ({
        checkedKeys: []
    }),
    computed: {
        visibleGroups() {
            const pendingTypes = this.documents.map(
                ({ documentType }) => documentType
            );
            return LEGAL_CONSENT_GROUPS.filter((group) =>
                group.documentTypes.some((type) => pendingTypes.includes(type))
            );
        },
        allChecked() {
            return (
                this.visibleGroups.length > 0 &&
                this.visibleGroups.every((group) =>
                    this.checkedKeys.includes(group.key)
                )
            );
        }
    },
    watch: {
        allChecked(isComplete) {
            if (isComplete !== this.value) this.$emit("input", isComplete);
        },
        visibleGroups(groups) {
            const visibleKeys = groups.map(({ key }) => key);
            this.checkedKeys = this.checkedKeys.filter((key) =>
                visibleKeys.includes(key)
            );
        }
    },
    methods: {
        labelOf(documentType) {
            return LEGAL_DOCUMENT_LABELS[documentType] || documentType;
        },
        toggleGroup(key) {
            this.checkedKeys = this.checkedKeys.includes(key)
                ? this.checkedKeys.filter((item) => item !== key)
                : [...this.checkedKeys, key];
        }
    }
};
</script>
